import React from 'react';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import SEO from '../../components/common/SEO';

const PrivacyPolicy = () => (
  <div className="min-h-screen flex flex-col">
    <SEO
      title="Privacy Policy"
      description="Read Elixir's privacy policy to learn how we protect your data and respect your privacy when you shop for Mediterranean honey."
      keywords="Elixir privacy policy, honey privacy, Mediterranean honey privacy, data protection, customer privacy"
    />
    <Header />
    <main className="flex-grow bg-white py-12 px-4 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-[#d4af37] mb-6">Privacy Policy</h1>
      <p className="mb-4">At Elixir, we value your privacy and are committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data when you visit our website or make a purchase.</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>Personal details (name, email, address, phone) provided during checkout or account creation.</li>
        <li>Order history and payment information (processed securely via our payment provider).</li>
        <li>Browsing data (cookies, analytics) to improve your experience.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">How We Use Your Information</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>To process and deliver your orders.</li>
        <li>To communicate with you about your order or our products.</li>
        <li>To improve our website and services.</li>
        <li>To comply with legal obligations.</li>
      </ul>
      <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>You can request access, correction, or deletion of your personal data at any time.</li>
        <li>You can opt out of marketing communications.</li>
      </ul>
      <p className="mt-4">We never sell your data. For questions, contact us at <a href="mailto:team@elixir-honey.com" className="text-[#d4af37] underline">team@elixir-honey.com</a>.</p>
    </main>
    <Footer />
  </div>
);

export default PrivacyPolicy; 